var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('div',{staticClass:"logo"}),_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$route.meta.title))]),_c('p',[_vm._v(_vm._s(_vm.$route.meta.description))])])])}
var staticRenderFns = []

export { render, staticRenderFns }